/** Minimal client-side HTML sanitization for Craft embed blocks. */
export function sanitizeHtmlClient(html: string): string {
  if (!html) return "";
  if (typeof document === "undefined") return html;
  const template = document.createElement("template");
  template.innerHTML = html;
  template.content.querySelectorAll("script, iframe, object, embed, form").forEach((el) => el.remove());
  template.content.querySelectorAll("*").forEach((el) => {
    for (const attr of [...el.attributes]) {
      if (attr.name.startsWith("on")) el.removeAttribute(attr.name);
    }
  });
  return template.innerHTML;
}
